import Service from "../../Services";

const OurService = {
  namespaced: true,
  state: {
    form: {
      id: "",
      title_th: "",
      title_en: "",
      intro_th: "",
      intro_en: "",
      path: "",
      image_illustration_show: "",
      image_illustration: "",
      image_cover_show: "",
      image_cover: "",
      is_publish: true,
      details: []
    },
    detail: {
      id: "",
      our_service_id: "",
      title_th: "",
      title_en: "",
      detail_th: "",
      detail_en: "",
      image_show: "",
      image: "",
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    GET_FORM_DETAIL: (state, res) => {
      state.detail = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        title_th: "",
        title_en: "",
        intro_th: "",
        intro_en: "",
        image_illustration_show: "",
        image_illustration: "",
        image_cover_show: "",
        image_cover: "",
        is_publish: true,
        details: []
      };
    },
    CLEAR_FORM_DETAIL_DATA: state => {
      state.detail = {
        id: "",
        our_service_id: "",
        title_th: "",
        title_en: "",
        detail_th: "",
        detail_en: "",
        image_show: "",
        image: "",
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getOurService({ commit }, {page,search}) {
      return Service.OurServiceAPI.getOurService(page,search);
    },
    // eslint-disable-next-line no-unused-vars
    showOurService({ commit }, id) {
      return Service.OurServiceAPI.showOurService(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveOurService({ commit }, { id, data }) {
      if (id) {
        return Service.OurServiceAPI.updateOurService(id, data);
      } else {
        return Service.OurServiceAPI.createOurService(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteOurService({ commit }, id) {
      return Service.OurServiceAPI.deleteOurService(id);
    },
    setFormOurService({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
    clearFormDetailData({ commit }) {
      commit("CLEAR_FORM_DETAIL_DATA");
    },
    getOurServiceDetailFromServiceId({ commit }, id) {
      return Service.OurServiceAPI.getOurServiceDetailFromServiceId(id);
    },
    showOurServiceDetail({ commit }, id) {
      return Service.OurServiceAPI.showOurServiceDetail(id);
    },
    setFormOurServiceDetail({ commit }, res) {
      commit("GET_FORM_DETAIL", res);
    },
    saveOurServiceDetail({ commit }, { id, data }) {
      if (id) {
        return Service.OurServiceAPI.updateOurServiceDetail(id, data);
      } else {
        return Service.OurServiceAPI.createOurServiceDetail(data);
      }
    },
  }
};
export default OurService;
